// extracted by mini-css-extract-plugin
export var postImage = "post-module--post-image--1XfYf";